/* eslint-disable static-service/require-stories -- we have stories for the Markdown component */
import {StyleSheet} from "aphrodite";

import SimpleMarkdown from "@khanacademy/simple-markdown";
import {addStyle} from "@khanacademy/wonder-blocks-core";

import type {MarkdownRule} from "../types.ts";

// This regular expression matches strings that are surrounded by == and the
// string can include any characters, including escaped characters (preceded by
// a backslash \). The string must not start with a whitespace character.
// 1. (={2}): first capture group that matches exactly two equals signs ==.
// 2. (?![\s]): is a negative lookahead that asserts what immediately follows
//    is not a whitespace character.
// 3. ((?:\\[\s\S]|[^\\])+?): is a capturing group that matches one or more of
//    the following, as few times as possible (due to the ? making it lazy):
//        a. \\[\s\S]: matches a backslash \ followed by any character.
//        b. [^\\]: matches any character that is not a backslash \.
// 4. ={2}: third capture group that matches exactly two equals signs ==.
// 5. (?!=): is another negative lookahead that asserts what immediately follows
//    is not an equals sign =. This means the == at the end must not be
//    followed by another =.
const MARK_R = /^(={2})(?![\s])((?:\\[\s\S]|[^\\])+?)(={2})(?!=)/;

const StyledMark = addStyle("mark");

// Output rule for inline text highlighting. Handles text wrapped in
// a pair of `=`.
// Ex. ==this is highlighted text==
export const markRule: Readonly<MarkdownRule> = {
    order: SimpleMarkdown.defaultRules.em.order /* same as em */,
    match: SimpleMarkdown.inlineRegex(MARK_R),
    quality: (capture) => {
        // loses all ties against `u`, `em`, and `strong`
        return capture[0].length - 0.1;
    },
    parse: (capture, parse, state) => {
        return {
            content: parse(capture[2], state),
        };
    },
    react: (node, output, state) => {
        return (
            <StyledMark key={state.key} style={styles.mark}>
                {output(node.content, state)}
            </StyledMark>
        );
    },
};

const styles = StyleSheet.create({
    mark: {
        color: "inherit",
        backgroundColor: "#BFE6DD",
    },
});
